import React from 'react';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {DialogTypes} from 'common/names';
import Dialog from 'components/Dialog';
// import FormikBrowseFileInput from 'components/inputs/FormikBrowseFileInput';
import FormikTextField from 'components/inputs/FormikTextField';
import Panel from 'components/Panel';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import {useTranslation} from 'react-i18next';
import {
   ImportSSHKeyPairNames,
   ImportSSHPublic,
   importSSHPublicSchema,
} from 'types/diplomat/keys/ImportSSHKeyPair';
import {useDispatch, useSelector} from 'react-redux';
import selectors from 'features/layout/redux/selectors';
import {folderNames} from 'common/constants';
import {usePostApi} from 'common/hooks/usePostApi';
import api from 'api';
import {castToSend} from 'common/yup/castToSend';
import {layoutActions} from 'features/layout/redux';
import OverwriteConfirmation from 'features/layout/DialogRoutes/dialogs/keys/components/OverwriteConfirmation';
import {useModal} from 'common/hooks/useModal';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';

type ImportSSHPublicKeyProps = {
   onClose: () => void;
   data?: INav;
};

const ImportSSHPublicKey = ({data, onClose}: ImportSSHPublicKeyProps) => {
   const {t} = useTranslation();
   const dispatch = useDispatch();
   const keys = useSelector(selectors.clientSshKeys);
   const defaultFolder = useSelector(selectors.folderByName(folderNames.SSH_PUBLIC_KEYS));
   const {request} = usePostApi(api.importSSHPublic);
   const {open, handleOpen, handleClose} = useModal();
   const onSuccess = () => {
      dispatch(layoutActions.loadTreeNav());
      onClose();
   };

   const [submitProps, setSubmitProps] = React.useState<
      [ImportSSHPublic, FormOnSubmitHelpers<ImportSSHPublic>]
   >();
   const handleSubmit = (
      values: ImportSSHPublic,
      helpers: FormOnSubmitHelpers<ImportSSHPublic>
   ) => {
      if (!values.overwrite && keys.some((key) => key.name === values.keyName)) {
         setSubmitProps([values, helpers]);
         handleOpen();
         return;
      }
      request(JSON.stringify(castToSend(importSSHPublicSchema, values)), {
         onSuccess,
         helpers,
         onFailure: (e) => {
            helpers.setSubmitting(false);
            helpers.setErrors(e);
         },
      });
   };
   return (
      <Dialog maxWidth="sm" header={DialogTypes.ImportSSHPublic.dialogName} close={onClose}>
         <Formik
            enableReinitialize
            initialValues={importSSHPublicSchema.cast({folderID: data?.id || defaultFolder?.id})}
            validationSchema={importSSHPublicSchema}
            onSubmit={handleSubmit}
         >
            <>
               <OverwriteConfirmation
                  open={open}
                  keyType={t('an SSH key')}
                  keyName={submitProps?.[0].keyName}
                  onOk={() => {
                     handleSubmit({...submitProps![0], overwrite: true}, submitProps![1]);
                     handleClose();
                  }}
                  onCancel={handleClose}
               />
               <Panel>
                  {/* <FormikBrowseFileInput name={'filePath'} label={t('SSH Key File')} /> */}
                  <FormikTextField
                     autoFocus
                     name={ImportSSHKeyPairNames.filePath}
                     label={t('SSH Public Key Body')}
                     multiline
                     rows={8}
                  />
                  <FormikTextField autoFocus name={'keyName'} label={t('Key Name')} />
               </Panel>
               <FormFooterButtons cancel={onClose} />
            </>
         </Formik>
      </Dialog>
   );
};

export default ImportSSHPublicKey;
